<h2 mat-dialog-title>Uploaded Files</h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
<mat-dialog-content>
  <div>
   <img [src]="url" alt="Preview Not Available for this Format. Click here to download" (click)="openAttachment(url)"/>
  </div>
 
</mat-dialog-content>
